import React from 'react';
import { ReactComponent as Info } from 'src/assets/info-icon.svg';
import { ReactComponent as Pattern } from 'src/assets/uaf-pattern.svg';
import css from './modal.module.scss';
import { BaseInfo } from 'src/types/quiz';
import QuizButtons from './modal-buttons';

interface QuizInfoProps {
  infoType?: string | JSX.Element;
  InfoModalTypes: BaseInfo;
  onApply: () => void;
  onCancel: () => void;
}

export default function QuizInfo({ infoType, InfoModalTypes, onApply, onCancel }: Readonly<QuizInfoProps>) {
  const applyMsg = infoType === InfoModalTypes.Exit ? 'Так, хочу вийти' : 'Перейти до тестування';
  const cancelMsg = infoType === InfoModalTypes.Exit ? 'Ні,повернутися' : 'Скасувати';

  const info = {
    cancelMsg: cancelMsg,
    applyMsg: applyMsg,
    onApply: onApply,
    onCancel: onCancel,
    applyBtnClass:
      infoType === InfoModalTypes.TryAgain || infoType === InfoModalTypes.Congrats ? css.resultBtn : css.apply,
    infoText: infoType ?? (
      <>
        <h2>До відома претендентів</h2>
        <p>
          Для того, щоб мати можливість подати свою кандидатуру на вакансію необхідно пройти тестування. Після успішного
          завершення тестування буде надана контактна електронна пошта, на яку необхідно надіслати резюме та додати
          назву вакансії в темі.
        </p>
      </>
    )
  };

  const showActionBtns = infoType !== InfoModalTypes.TryAgain && infoType !== InfoModalTypes.Congrats;

  return (
    <React.Fragment>
      <div className={css.leftPart}>
        <Info />
        <Pattern className={css.pattern} />
      </div>
      <div className={css.quiz}>
        <div className={css.quiz_text}>{info.infoText}</div>
        {showActionBtns ? (
          <QuizButtons {...info} />
        ) : (
          <div className={css.buttons}>
            <button className={info.applyBtnClass} onClick={info.onApply}>
              Зрозуміло
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
